import React, { PropsWithChildren, useContext } from 'react';
import { createPortal } from 'react-dom';
import { Box, xcss } from '@atlaskit/primitives';
import { TourSpotlightContext } from './TourSpotlightContext';

import { PopoverTarget } from '@atlaskit/spotlight/popover-target';
import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';

const activeTargetStyles = xcss({
	borderRadius: 'radius.small',
	outlineColor: 'color.border.focused',
	outlineStyle: 'solid',
	outlineWidth: 'border.width.focused',
	outlineOffset: 'space.025',
});

export type TourSpotlighTargetName = string & { readonly brand: unique symbol };

export const TourSpotlightTarget = ({
	children,
	name,
}: PropsWithChildren<{ name: TourSpotlighTargetName }>): React.JSX.Element => {
	const context = useContext(TourSpotlightContext);
	const isActive = context !== null && context.activeTarget === name;
	const content = isActive ? context.content : null;

	return (
		<PopoverProvider>
			<PopoverTarget data-spotlight-target={name}>
				<Box xcss={isActive ? activeTargetStyles : undefined}>{children}</Box>
			</PopoverTarget>
			{/* Portal the card to document.body so it escapes any ancestor stacking contexts
          and renders above the backdrop (z-index: 400) at root level */}
			{content && createPortal(content, document.body)}
		</PopoverProvider>
	);
};
